import React from "react";
import Input from "../ui/Input";

const ThirdForm = ({ otp, onOtpChange, handleNext, step }) => {
  return (
    <div>
      <Input
        name="Otp"
        type="text"
        value={otp}
        onChange={(e) => onOtpChange(e)}
        handleNext={handleNext}
        step={step}
      />
    </div>
  );
};
export default ThirdForm;
